import React from "react";
import "../../../css/DesignSystem/Buttons/Buttons.css";

class ButtonSmall extends React.Component {
  constructor() {
    super();

    this.state = {
      clicked: false,
      greenClicked: false,
    };
  }

  render() {
    const { buttonText, onClick } = this.props;
    return (
      <div
        className={`Button-Small ${this.state.clicked ? "clicked" : ""}`}
        onClick={() => {
          this.setState({ clicked: !this.state.clicked });
          onClick(); // Call the onClick prop function
        }}
      >
        <div className="Button-Text">{buttonText}</div>
      </div>
    );
  }
}

export default ButtonSmall;
